import "./ReportBox.scss"
import {RaikoLabel} from "@moeindal/base-raiko-panel-components";


export const ReportBox = ({icon, label, action}) => {


    return (
        <div
            onClick={action}
            className={"reportBoxContainer"}>
            <RaikoLabel text={label}/>
            <img src={icon} alt=""/>
        </div>
    )
}


export const ReportsItemTypes = {
    PDF: {
        id: "PDF",
        type: "pdf"
    },
    XLSX: {
        id: "XLSX",
        type: "xlsx"
    },
}